// export enum SubsAndPlansActionTypes {
//     SUBSCRIPTION_PLAN_LIST = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST',
//     SUBSCRIPTION_PLAN_LIST_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST_SUCCESS',
//     SUBSCRIPTION_PLAN_LIST_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST_ERROR',

//     SUBSCRIPTION_PLAN_DELETE = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE',
//     SUBSCRIPTION_PLAN_DELETE_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE_SUCCESS',
//     SUBSCRIPTION_PLAN_DELETE_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE_ERROR',

//     SUBSCRIPTION_PLAN_ADD = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD',
//     SUBSCRIPTION_PLAN_ADD_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD_SUCCESS',
//     SUBSCRIPTION_PLAN_ADD_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD_ERROR',

//     SUBSCRIPTION_ADD = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD',
//     SUBSCRIPTION_ADD_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_SUCCESS',
//     SUBSCRIPTION_ADD_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_ERROR',
// }

export enum SubsAndPlansActionTypes {
    SUBSCRIPTION_PLAN_LIST = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST',
    SUBSCRIPTION_PLAN_LIST_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST_SUCCESS',
    SUBSCRIPTION_PLAN_LIST_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_LIST_ERROR',

    SUBSCRIPTION_PLAN_DELETE = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE',
    SUBSCRIPTION_PLAN_DELETE_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE_SUCCESS',
    SUBSCRIPTION_PLAN_DELETE_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_DELETE_ERROR',

    SUBSCRIPTION_PLAN_ADD = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD',
    SUBSCRIPTION_PLAN_ADD_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD_SUCCESS',
    SUBSCRIPTION_PLAN_ADD_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_ADD_ERROR',

    SUBSCRIPTION_ADD = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD',
    SUBSCRIPTION_ADD_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_SUCCESS',
    SUBSCRIPTION_ADD_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_ERROR',

    SUBSCRIPTION_LIST = '@@subscriptionsAndPlans/SUBSCRIPTION_LIST',
    SUBSCRIPTION_LIST_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_LIST_SUCCESS',
    SUBSCRIPTION_LIST_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_LIST_ERROR',

    SUBSCRIPTION_PLAN_UPDATE = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE',
    SUBSCRIPTION_PLAN_UPDATE_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE_SUCCESS',
    SUBSCRIPTION_PLAN_UPDATE_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE_ERROR',

    SUBSCRIPTION_PLAN_UPDATE_STATUS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE_STATUS',
    SUBSCRIPTION_PLAN_UPDATE_STATUS_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE_STATUS_SUCCESS',
    SUBSCRIPTION_PLAN_UPDATE_STATUS_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_PLAN_UPDATE_STATUS_ERROR',

    SUBSCRIPTION_SCHEDULE = '@@subscriptionsAndPlans/SUBSCRIPTION_SCHEDULE',
    SUBSCRIPTION_SCHEDULE_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_SCHEDULE_SUCCESS',
    SUBSCRIPTION_SCHEDULE_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_SCHEDULE_ERROR',

    SUBSCRIPTION_ADD_MODULES = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_MODULES',
    SUBSCRIPTION_ADD_MODULES_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_MODULES_SUCCESS',
    SUBSCRIPTION_ADD_MODULES_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_MODULES_ERROR',

    RESET_SUB_SUCCESS = 'RESET_SUB_SUCCESS',

    // SUBSCRIPTION_ADD = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD',
    // SUBSCRIPTION_ADD_SUCCESS = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_SUCCESS',
    // SUBSCRIPTION_ADD_ERROR = '@@subscriptionsAndPlans/SUBSCRIPTION_ADD_ERROR',
}
